export const en = {
    gteMessage: 'Daily budget cannot be more than {maxValue}',
    lteMessage: 'Daily budget sum cannot be less than {minValue}',
    requiredMessage: 'Daily budget amount not indicated'
};
